import { ShieldCheck } from "@phosphor-icons/react";

export function PageHeader() {
  return (
    <header className="border-border-subtle sticky top-0 z-30 border-b bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between px-5 sm:px-8 lg:px-10">
        <div className="flex flex-col justify-center gap-0.5" aria-label="VELUX Smart Climate">
          <span className="text-muted text-[10px] leading-3 font-bold tracking-[0.11em] uppercase">
            VELUX
          </span>
          <span className="text-primary text-[16px] leading-5">Smart Climate</span>
        </div>
        <div className="bg-success-subtle text-primary flex items-center gap-2 rounded-sm px-3 py-2 text-[11px] leading-4">
          <ShieldCheck className="text-success size-4" weight="fill" aria-hidden />
          <span className="hidden sm:inline">Secure credential sharing</span>
          <span className="sm:hidden">Secure sharing</span>
        </div>
      </div>
    </header>
  );
}

export function PageFooter() {
  return (
    <footer className="bg-primary text-white">
      <div className="mx-auto flex max-w-[1120px] flex-col gap-3 px-5 py-7 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-10">
        <p className="text-[13px]">VELUX Smart Climate beta programme</p>
        <p className="max-w-[620px] text-[11px] leading-4 text-white/55 sm:text-right">
          Your network details are used only to prepare the two connectors in your kit.
        </p>
      </div>
    </footer>
  );
}
